export default __webpack_public_path__ + "static/media/culture_EP14.6cc66717.png";